/**
 * Created by bailey on 17/2/20.
 */
import './style/index.less';
import dataTable from './data-table';

export default dataTable;



// WEBPACK FOOTER //
// ./vb/components/data-table/index.js